<template>
  <div class="l-container AdvisorsAdd">
    <form class="h-adr">
      <p class="m-label">新規追加</p>
      <advisor-form :advisor="advisor" :watch="watch"></advisor-form>
      <btn class="u-btn u-btn--add" @click.native="postAdvisor"><i class="fa fa-user-plus"></i>ADを新規追加</btn>
    </form>
  </div>
</template>

<script>
export default {
  computed: {
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        console.log(el)
        console.log(binding)
      }
    }
  },
  data () {
    return {
      asc: '',
      desc: '',
      sortState: '',

      advisor: {
        f_name: '',
        l_name: '',
        office: ''
      },

      watch: {
        office: ''
      }
    }
  },
  watch: {
    'watch.office': function (now, old) {
      if (now) {
        this.advisor.office = now.value
      } else {
        this.advisor.office = ''
      }
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //   })
  // },
  methods: {
    postAdvisor () {
      this.$store.dispatch('postAdvisor', {
        this: this,
        advisor: this.advisor
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  margin-bottom: 13px;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
</style>

<style lang="scss">
.AdvisorsAdd {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// AdvisorsAdd.vue?5f65f02c